/**
 * Marks an audience whose definition changed since its last count — the count shown is for a PRIOR
 * definition, not the current one (minimum-artifact §6.2 / brief §Product-surface). A warning icon whose
 * hover/focus tooltip explains what's stale; used on every surface that shows a count. It says only WHY
 * it's stale — running a recount is the detail page's refresh button, the one place a count can run.
 */
import { TriangleAlert } from 'lucide-react';

import { ActionTooltip } from '@/_shared/components/ActionTooltip';
import { cn } from '@/_shared/lib/utils';

const STALE_MESSAGE = 'Size is stale — the definition changed since it was last calculated.';

export function StaleIndicator({ className }: { className?: string }): React.ReactElement {
  return (
    <ActionTooltip show message={STALE_MESSAGE} className={cn('items-center text-warning', className)}>
      <TriangleAlert className="size-3.5" aria-hidden />
      <span className="sr-only">Stale</span>
    </ActionTooltip>
  );
}
